<template>
  <div>
    <header class="index-banner">
      <!-- nav -->
      <nav class="main-header">
        <div id="brand" data-aos="zoom-in-up">
          <div>
            <h1>
              <img src="images/logo.png" style="height: 75px" alt="My Logo" />
            </h1>
          </div>
        </div>
        <div id="menu">
          <div id="menu-toggle">
            <div id="menu-icon">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
          </div>
          <ul
            class="text-center text-capitalize nav-agile"
            data-aos="zoom-in-up"
          >
            <li>
              <a href="/" class="active">Accueil</a>
            </li>
            <li>
              <a href="#choose" class="scroll">Pourquoi nous ?</a>
            </li>
            <li>
              <a href="#pricing" class="scroll">Nos formations</a>
            </li>
            <li>
              <a href="#faq" class="scroll">Nos Réalisations</a>
            </li>
            <li>
              <a href="#contact" class="scroll">Nous contacter</a>
            </li>
          </ul>
        </div>
      </nav>
      <!-- //nav -->
      <!-- banner -->
      <div class="banner layer" id="home">
        <div class="container">
          <div class="row banner-text">
            <div class="slider-info col-lg-8">
              <div class="agileinfo-logo mt-5">
                <h2 data-aos="fade-down">
                  <span>
                    <img src="images/favicon.png" alt="" />
                  </span>
                  Solutions modernes -
                </h2>
              </div>
              <h3 class="txt-w3_agile" data-aos="fade-down">
                L'Excellence du Résultat
              </h3>
              <a
                class="btn mt-4 mr-2 text-capitalize"
                data-aos="fade-up"
                href="#"
                data-toggle="modal"
                data-target="#exampleModalCenter1"
                role="button"
                >Détails</a
              >
              <a
                class="btn mt-4 text-capitalize"
                data-aos="fade-up"
                href="#"
                data-toggle="modal"
                data-target="#exampleModal"
                role="button"
                >Regarder en vidéo <i class="fas fa-play-circle"></i
              ></a>
            </div>
            <div
              class="col-lg-4 col-md-8 mt-lg-0 mt-5 banner-form"
              data-aos="fade-left"
            >
              <h5>
                <i class="fas mr-2 fa-laptop"></i> S'inscrire gratuitement
              </h5>
              <form @submit.prevent="sendEmail" class="mt-4" method="post">
                <input
                  class="form-control"
                  type="text"
                  v-model="commonObject.nom"
                  name="nom"
                  placeholder="Nom"
                  required="true"
                />
                <input
                  class="form-control"
                  type="text"
                  name="prenoms"
                  v-model="commonObject.prenoms"
                  placeholder="Prénoms"
                  required="true"
                />
                <input
                  class="form-control"
                  type="email"
                  name="email"
                  v-model="form.email"
                  placeholder="Votre email"
                  required="true"
                />
                <input
                  class="form-control"
                  type="text"
                  name="telephone"
                  v-model="commonObject.contact"
                  oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                  placeholder="Numéro de téléphone"
                  required="true"
                />

                <input
                  class="form-control text-capitalize"
                  type="submit"
                  value="S'inscrire"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- //banner -->
    </header>
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import emailjs from "emailjs-com";

export default {
  name: "Header-Item",
  data() {
    return {
      commonObject: {
        prenoms: "",
        nom: "",
        email: "",
        contact: "",
        message: "",
      },

      form: {
        title: "Inscription LogikTech",
        name: "",
        time: new Date(),
        message: "",
        email: "",
      },
    };
  },
  methods: {
    /*submitForm() {
      this.commonObject.message = " Inscription depuis le banner ";
      document.getElementById("cover-spin").style.visibility = "visible";
      axios
        .post("https://localhost:1307/microservices/send-mail", this.commonObject)
        .then(
          function () {
            console.clear();
            this.clearCommonObject();
            this.showToatInfo();
            document.getElementById("cover-spin").style.visibility = "hidden";
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error);
          this.showToatError();
          document.getElementById("cover-spin").style.visibility = "hidden";
        });
    },*/

    sendEmail() {
      document.getElementById("cover-spin").style.visibility = "visible";
      this.form.name = this.commonObject.nom + ' ' + this.commonObject.prenoms;
      this.form.message = this.form.message + ' ' + this.commonObject.contact+' - '+this.form.email;
      emailjs
        .send(
          "service_2vinkxj",
          "template_8yg8vyo",
          this.form,
          "8KlaploLURmymcoQO" // ou public key
        )
        .then(() => {
          this.showToatInfo('Email envoyé avec succès !');
          this.form = { name: "", email: "", message: "" };
          this.commonObject = { nom: "", prenoms: "", contact: "" };
          document.getElementById("cover-spin").style.visibility = "hidden";
          console.clear();
        })
        .catch((error) => {
          showToatError();
          document.getElementById("cover-spin").style.visibility = "hidden";
        });
    },

    showToatError() {
      toast.error("Problème de connexion. Veuillez réessayer ultérieurement !!!",{
          autoClose: 2000,
        }
      );
    },

    showToatInfo() {
      toast.info("Votre inscription est enregistrée !", {
        autoClose: 2400,
      });
    },

    clearCommonObject() {
      this.commonObject.message = "";
      this.commonObject.nom = "";
      this.commonObject.prenoms = "";
      this.commonObject.email = "";
      this.commonObject.contact = "";
    },
  },
};
</script>

<style scoped>
</style>